"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _ParentTab = _interopRequireDefault(require("./ParentTab"));
var _SidenavLink = _interopRequireDefault(require("./SidenavLink"));
var _SidenavListItem = _interopRequireDefault(require("./SidenavListItem"));
var SidenavTab = function SidenavTab(props) {
  var index = props.index,
    onClick = props.onClick,
    persistDrawerState = props.persistDrawerState,
    selectedTab = props.selectedTab,
    focusedTab = props.focusedTab,
    sidenavIsOpen = props.sidenavIsOpen,
    sidenavWidth = props.sidenavWidth,
    tab = props.tab,
    onKeyDown = props.onKeyDown,
    onFocus = props.onFocus;
  var automationid = tab.automationid,
    dataMetrics = tab.dataMetrics,
    icon = tab.icon,
    route = tab.route,
    text = tab.text;
  var isSelected = selectedTab && selectedTab.tabIndex === index;
  var isFocused = focusedTab && focusedTab.tabIndex === index;
  if (route) {
    return /*#__PURE__*/_react["default"].createElement(_SidenavLink["default"], {
      automationid: automationid,
      dataMetrics: dataMetrics,
      isFocused: isFocused,
      onClick: onClick,
      onKeyDown: onKeyDown,
      route: route
    }, /*#__PURE__*/_react["default"].createElement(_SidenavListItem["default"], {
      icon: icon,
      isChildSelected: false,
      isFocused: isFocused,
      isSelected: isSelected,
      sidenavWidth: sidenavWidth,
      text: text,
      tabIndex: index
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_ParentTab["default"], {
    focusedTab: focusedTab,
    isChildSelected: index === selectedTab.tabIndex,
    isFocused: isFocused,
    isSelected: isSelected,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    persistDrawerState: persistDrawerState,
    selectedTab: selectedTab,
    sidenavIsOpen: sidenavIsOpen,
    sidenavWidth: sidenavWidth,
    tab: tab,
    tabIndex: index
  });
};
SidenavTab.defaultProps = {
  sidenavIsOpen: false
};
SidenavTab.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If the side nav is being navigated by keyboard this
   * is the currently selected tab.
   */
  focusedTab: _propTypes["default"].shape({
    tabIndex: _propTypes["default"].number,
    tabRoute: _propTypes["default"].string
  }).isRequired,
  /**
   * The tab's location in the list of all Sidenav tabs
   */
  index: _propTypes["default"].number.isRequired,
  /**
   * Callback function when a SidenavTab is clicked
   */
  onClick: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func.isRequired,
  /**
   * Callback function when the sidenav has a key down event
   */
  onKeyDown: _propTypes["default"].func.isRequired,
  /**
   * Persist local storage state for expanded tabs.
   */
  persistDrawerState: _propTypes["default"].bool,
  /**
   * The single tab currently selected
   */
  selectedTab: _propTypes["default"].shape({
    tabIndex: _propTypes["default"].number.isRequired,
    tabRoute: _propTypes["default"].string
  }).isRequired,
  /**
   * True if the Sidenav is expanded (horizontally, not necessarily expanded vertically)
   */
  sidenavIsOpen: _propTypes["default"].bool,
  /**
   * Width of the Sidenav when expanded
   */
  sidenavWidth: _propTypes["default"].number,
  /**
   * SidenavTab data
   */
  tab: _propTypes["default"].shape({
    automationid: _propTypes["default"].string,
    dataMetrics: _propTypes["default"].string,
    icon: _propTypes["default"].element.isRequired,
    route: _propTypes["default"].string,
    subSections: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      childTabs: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].shape({
        automationid: _propTypes["default"].string,
        dataMetrics: _propTypes["default"].string,
        subdomain: _propTypes["default"].bool
      }), _propTypes["default"].shape({
        automationid: _propTypes["default"].string,
        dataMetrics: _propTypes["default"].string,
        route: _propTypes["default"].string.isRequired,
        text: _propTypes["default"].string.isRequired
      })])),
      header: _propTypes["default"].string
    })),
    text: _propTypes["default"].string.isRequired
  }).isRequired
} : {};
var _default = SidenavTab;
exports["default"] = _default;